<h1 class="cg-h1">{{ 'am.pageTitle' | translate }}</h1>

<cigna-process-steps
  class="cg-hide-for-print"
  [steps]="steps$ | async"
  [activeStep]="2"
  [hiddenSteps]="hiddenSteps$ | async"
></cigna-process-steps>

<h3 class="cg-h3">{{ 'am.accessBulk.header' | translate }}</h3>
<p class="cg-margin-top-none cg-margin-bottom-xl">
  {{ 'am.accessBulk.subHeader' | translate }}
</p>

<div class="cg-multicolumn-list cg-multi-column-list-lg-3 cg-margin-bottom-xl">
  <div
    *ngFor="
      let user of selectedUsers$ | async;
      first as firstUser;
      last as lastUser
    "
    class="cg-multicolumn-list__item cg-margin-bottom-md"
  >
    <cigna-user-summary-item
      mode="edit"
      [user]="user"
      [allowRemove]="!(firstUser && lastUser)"
      (viewAccessForUser)="openUserAccessDialog(user)"
      (removeUserFromEdit)="openRemoveUserFromEditingDialog(user)"
    >
    </cigna-user-summary-item>
  </div>
</div>

<h4 class="cg-margin-top-xl cg-margin-bottom-sm">
  {{ 'am.accessBulk.tinHeader' | translate }}
</h4>
<div *ngIf="(userLob$ | async) === LOB_MEDBH" class="cg-margin-top-xs">
  {{ 'am.common.lobTinMessage' | translate }}
  <b>
    <a [href]="'/my-practice/manage-access' | crossOriginLink">{{
      'am.common.lobTinRedirect' | translate
    }}</a>
  </b>
</div>
<div class="cg-contrast-block-on-light">
  <cigna-select-tins-group
    [allTins]="allTins$ | async"
    [currentTins]="bulkEditSelectedTins$ | async"
    [columns]="3"
    (selectionsChange)="tinSelectionsChange($event)"
  >
  </cigna-select-tins-group>
</div>
<div
  *ngIf="tinInputDirty && (bulkEditSelectedTinsValid$ | async) === false"
  class="cg-error-msg"
>
  <cigna-icon type="exclamation-circle"></cigna-icon>
  <span>{{ 'am.accessBulk.tinError' | translate }}</span>
</div>

<h4 class="cg-margin-top-xl cg-margin-bottom-sm">
  {{ 'am.accessBulk.entitlementHeader' | translate }}
  <span class="cg-header-subtext">
    (<button
      style="padding: 0"
      cignaButton="link"
      (click)="openExplainAccessDialog()"
    >
      {{ 'am.accessBulk.entitlementHelpLink' | translate }}</button
    >)
  </span>
</h4>

<div class="cg-contrast-block-on-light cg-margin-bottom-sm">
  <cigna-entitlement-group
    [isPilotMHKUser]="isPilotMHKUser$ | async"
    [allEntitlements]="allEntitlements$ | async"
    [currentEntitlements]="bulkEditSelectedEntitlements$ | async"
    [showApplyJobRole]="false"
    [bulkEdit]="true"
    (selectionsChange)="entitlementsChange($event)"
  >
  </cigna-entitlement-group>
</div>

<div
  *ngIf="(bulkEditSelectedEntitlementsValid$ | async) === false"
  class="cg-error-msg"
>
  <cigna-icon type="exclamation-circle"></cigna-icon>
  <span>{{ 'am.accessBulk.addUsersValidationError' | translate }}</span>
</div>

<div class="cg-margin-top-xl">
  <div
    class="cg-flex cg-margin-bottom-sm"
    *ngIf="(userType$ | async) === USER_TYPE_EXISTING"
  >
    <div>
      <cigna-icon
        type="alert-triangle"
        class="cg-color-warn cg-icon-sm cg-margin-right-sm"
      ></cigna-icon>
    </div>
    <strong>{{ 'am.accessBulk.submitWarning' | translate }}</strong>
  </div>
  <cigna-page-step-navigation
    [showPrevious]="true"
    [nextEnabled]="
      (bulkEditSelectedTinsValid$ | async) &&
      (bulkEditSelectedEntitlementsValid$ | async)
    "
    nextButtonLabel="Review"
    (previous)="previousScreen()"
    (next)="nextScreen()"
  >
  </cigna-page-step-navigation>
</div>
